import React from 'react';

import FastChoice from 'app/beta-editor/components/formatic/FastChoice';
import PathHeaderChoice from 'app/beta-editor/components/formatic/PathHeaderChoice';
import SmartChoice from 'app/beta-editor/components/formatic/SmartChoice';

const Choice = props => {
  if (props.choice.isPathHeader) {
    return <PathHeaderChoice {...props} />;
  }

  if (props.total > 250) {
    return <FastChoice {...props} />;
  }
  return <SmartChoice {...props} />;
};

export default Choice;
